export default __webpack_public_path__ + "static/media/Commander.5d0bc9c5.png";